import axios from 'axios';

export const getPageMode = () => axios.get('dev/GetPageMode');

export const getEnvironments = () => axios.get('dev/GetEnvironments');

export const getPortals = environmentId => axios.post('dev/GetPortals', { environmentId });

export const getModulesByPortal = params => axios.post('dev/getModulesByPortal', params);

export const getPages = params => axios.post('dev/GetAllPages', params);

export const getPageByName = params => axios.post('dev/GetPagesByName', params);

export const getConfigLayout = portalId => axios.post('dev/GetConfigLayout', { portalId });

export const saveConfigLayout = (portalId, file) => axios.post('dev/SaveConfigLayout', { portalId, file });

export const getMenus = params => axios.post('dev/GetMenus', params);

export const createMenu = params => axios.post('dev/CreateMenu', params);

export const updateMenu = params => axios.post('dev/UpdateMenu', params);

export const deleteMenu = params => axios.post('dev/DeleteMenu', params);

export const saveOrderMenu = params => axios.post('dev/SaveOrderMenu', params);

export const savePage = params => axios.post('dev/SavePage', params);

export const getModules = (environmentId) => axios.get(`dev/GetModules?EnvironmentId=${environmentId}`);

export const createModule = params => axios.post('dev/CreateModule', params);

export const deleteModule = moduleId => axios.post('dev/DeleteModule', moduleId);

export const updateModule = params => axios.post('dev/UpdateModule', params);

export const getStatusPortals = params => axios.post('dev/GetStatusPortals', params);

export const tooglePortalAccess = params => axios.post('dev/ChangeStatusPortals', params);
